import React from "react";
import flowerimg from "../../images/Services/flowers.png";
import diningimg from "../../images/Services/dining.png";
import transportimg from "../../images/Services/transport.png";
import speakerimg from "../../images/Services/speaker.png";
import eventimg from "../../images/Services/eventmonitor.png";
import decorimg from "../../images/Services/decor.png";
import cameraimg from "../../images/Services/camera.png";
import vendorimg from "../../images/Services/vendor.svg";
import lighting from "../../images/Services/lighting.svg";
import licenseimg from "../../images/Services/license.svg";
import tenting from "../../images/Services/tenting.svg";
import "./services.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Services() {
  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,

    // className: "client_logo_cont",
    // slidesToShow: 1,
    // slidesToScroll: 1,
    // speed: 500,
    adaptiveHeight: false,
    rows: 2,
    // centerPadding: "60px",
    slidesPerRow: 4,

    autoplay: true,
    speed: 800,
    responsive: [
      {
        breakpoint: 1330,
        settings: {
          rows: 2,
          slidesPerRow: 3,
        },
      },
      {
        breakpoint: 1020,
        settings: {
          rows: 2,
          slidesPerRow: 2,
          //   slidesToShow: 1,
        },
      },
      {
        breakpoint: 700,
        settings: {
          rows: 2,
          slidesPerRow: 1,
          //   slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="container">
      <p className="container_heading">
        <span className="heading_first">Our</span> Sevices
      </p>
      <Slider {...settings} className="services_cards">
        {/* <div className="services_cards"> */}
        <div>
          <div className="services_card_red">
            <img className="services_card_img" src={flowerimg} />
            <p className="services_card_text">Flowers and Decor</p>
          </div>
        </div>

        <div>
          <div className="services_card_grey">
            <img className="services_card_img" src={diningimg} />
            <p className="services_card_text">Dining and Caterers</p>
          </div>
        </div>

        <div>
          <div className="services_card_red">
            <img className="services_card_img" src={transportimg} />
            <p className="services_card_text">Arranging Transportation</p>
          </div>
        </div>

        <div>
          <div className="services_card_grey">
            <img className="services_card_img" src={speakerimg} />
            <p className="services_card_text">Arranging Guest Speakers</p>
          </div>
        </div>

        <div>
          <div className="services_card_red">
            <img className="services_card_img" src={eventimg} />
            <p className="services_card_text">Event Monitoring</p>
          </div>
        </div>

        <div>
          <div className="services_card_grey">
            <img className="services_card_img" src={cameraimg} />
            <p className="services_card_text">Video & Photography</p>
          </div>
        </div>

        <div>
          <div className="services_card_red">
            <img className="services_card_img" src={decorimg} />
            <p className="services_card_text">Wedding Stage Effects</p>
          </div>
        </div>

        <div>
          <div className="services_card_grey">
            <img
              style={{
                filter:
                  "invert(77%) sepia(49%) saturate(0%) hue-rotate(137deg) brightness(109%) contrast(97%)",
              }}
              className="services_card_img"
              src={vendorimg}
            />
            <p className="services_card_text">Selecting Venues / Vendors</p>
          </div>
        </div>

        <div>
          <div className="services_card_red">
            <img
              style={{
                filter:
                  "invert(77%) sepia(49%) saturate(0%) hue-rotate(137deg) brightness(109%) contrast(97%)",
              }}
              className="services_card_img"
              src={licenseimg}
            />
            <p className="services_card_text">License Arrangment</p>
          </div>
        </div>

        <div>
          <div className="services_card_grey">
            <img
              style={{
                filter:
                  "invert(77%) sepia(49%) saturate(0%) hue-rotate(137deg) brightness(109%) contrast(97%)",
              }}
              className="services_card_img"
              src={lighting}
            />
            <p className="services_card_text">Lighting </p>
          </div>
        </div>

        <div>
          <div className="services_card_red">
            <img
              style={{
                filter:
                  "invert(77%) sepia(49%) saturate(0%) hue-rotate(137deg) brightness(109%) contrast(97%)",
              }}
              className="services_card_img"
              src={tenting}
            />
            <p className="services_card_text">Tenting</p>
          </div>
        </div>

        {/* </div> */}
      </Slider>
    </div>
  );
}

export default Services;
